import { Form } from "@circle-react-uikit/Form";
import type { PostFormValues } from "@circle-react/components/QuickPostV3/data/types";
import { useComposerSpace } from "@circle-react/components/QuickPostV3/hooks/useComposerSpace";
import {
  isDisplayCardView,
  isPublishedPost,
} from "@circle-react/helpers/postHelpers";
import { Divider } from "@circleco/compass/components/Divider";
import { FormField } from "@circleco/compass/components/FormField";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";

import { CardViewThumbnailDropzone } from "./CardViewThumbnailDropzone";
import { SettingsSection } from "./SettingsSection";
import { SettingsSectionBody } from "./SettingsSectionBody";

export const DisplayFeaturingSection = () => {
  const { watch } = useFormContext<PostFormValues>();
  const { space } = useComposerSpace();
  const postId = watch("id");
  const status = watch("status");
  const isEditingPublishedPost = Boolean(postId) && isPublishedPost({ status });
  const shouldShowCardViewThumbnail = isDisplayCardView(space);

  return (
    <SettingsSection
      title={t("quick_post_v3.settings.sections.display_featuring")}
    >
      <SettingsSectionBody>
        {shouldShowCardViewThumbnail && (
          <>
            <FormField
              layout="horizontal"
              horizontalLayoutRatio="40/60"
              label={t("cardview_thumbnail")}
              labelTooltip={t("cardview_thumbnail_description")}
            >
              <CardViewThumbnailDropzone />
            </FormField>
            <Divider />
          </>
        )}
        <Form.ToggleSwitch
          name="hide_meta_info"
          label={t("post.hide_meta_info")}
          labelPosition="end"
        />
        {!space?.hide_from_featured_areas && (
          <Form.ToggleSwitch
            name="hide_from_featured_areas"
            label={t("post.hide_from_featured_areas")}
            labelPosition="end"
          />
        )}
        <Form.ToggleSwitch
          name="is_truncation_disabled"
          label={t("post.is_truncation_disabled")}
          labelPosition="end"
        />
        {isEditingPublishedPost && (
          <Form.ToggleSwitch
            name="pin_to_top"
            label={t("post.pin_to_top")}
            labelPosition="end"
          />
        )}
        {isEditingPublishedPost && !space?.hide_right_sidebar && (
          <Form.ToggleSwitch
            name="pinned_at"
            label={t("post.pinned_at")}
            labelPosition="end"
          />
        )}
      </SettingsSectionBody>
    </SettingsSection>
  );
};
